import React, { useContext, useEffect, useState } from "react";
import "./StockWidget.css";
import SocketContext from "../../../../context/SocketContext";
import moment from "moment";

const StockWidget = ({ item }) => {
  const socket = useContext(SocketContext);

  const [chng, setChng] = useState(0);
  const [percent, setPercent] = useState(0);
  const [ltp, setLtp] = useState(0);

  useEffect(() => {
    socket.emit("giverate", item.symbol_id);
    socket.on("trade" + item.symbol_id, trade);
    return () => socket.off("trade" + item.symbol_id, trade);
  }, []);

  const trade = (msg) => {
    if (!msg) return;
    const change = msg.LTP - msg.Previous_Close;
    setChng(change);
    setPercent((change / msg.Previous_Close) * 100);
    setLtp(msg.LTP);
  };

  const formattedChange = `${chng > 0 ? "+" : ""}${chng.toFixed(
    2
  )} (${percent.toFixed(2)}%)`;
  const changeClass = chng > 0 ? "positive" : chng < 0 ? "negative" : "";

  return (
    <div className="stock-card">
      <div className="stock-title flex">
        <div>
          {item.symbol_display}
        </div>
        <div className="pl-1 text-[9px] pt-[4px]" >
          {moment(item.expiry_date).format("DD-MMM")}
        </div>
      </div>
      <div className="stock-price">
        {ltp ? ltp.toLocaleString() : "--"}
        <div className={`stock-change ${changeClass}`}>{formattedChange}</div>
      </div>
    </div>
  );
};

export default StockWidget;
